var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTextRemoveFormatting extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
        >
          <g clip-path="url(#clip0_30492_97)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.40906 0.816678C1.18869 0.854022 0.960863 1.04002 0.854999 1.26898C0.804071 1.37912 0.803711 1.39249 0.803711 3.15591V4.93191L0.867335 5.06763C1.0967 5.55689 1.70249 5.67039 2.07833 5.29453C2.16221 5.21065 2.21719 5.12801 2.25233 5.033C2.30249 4.89742 2.30371 4.86327 2.30371 3.599V2.30391H4.76371H7.22371V8.78283V15.2618L6.30571 15.2688C5.40576 15.2758 5.38531 15.277 5.26534 15.3313C5.12186 15.3962 4.97057 15.5439 4.89173 15.6959C4.81157 15.8504 4.81128 16.1882 4.89115 16.339C4.9751 16.4974 5.10238 16.6238 5.25185 16.6972L5.38771 16.7639H7.97971H10.5717L10.6839 16.712C10.8348 16.6423 10.9929 16.4924 11.064 16.3515C11.1423 16.1965 11.1573 15.9413 11.0985 15.7644C11.0443 15.6011 10.8653 15.4087 10.6966 15.3324C10.5735 15.2767 10.5587 15.2758 9.65371 15.2688L8.73571 15.2618V8.78283V2.30391H11.1948H13.6538L13.6608 3.62991L13.6677 4.95591L13.7344 5.09177C13.8114 5.24845 13.9499 5.3833 14.1088 5.45626C14.265 5.52802 14.5592 5.52764 14.7164 5.45547C14.8602 5.38947 15.0218 5.22809 15.097 5.07529L15.1557 4.95591V3.16791V1.37991L15.093 1.24791C15.0132 1.08001 14.8796 0.946374 14.7117 0.866622L14.5797 0.80391L8.05171 0.800574C4.46131 0.79875 1.47211 0.805998 1.40906 0.816678ZM22.271 14.8878C22.198 14.9039 22.1008 14.9427 22.055 14.9739C22.0092 15.0051 21.3104 15.6905 20.5021 16.4969L19.0324 17.963L17.5381 16.4726C16.1086 15.0468 16.0375 14.9798 15.8997 14.9289C15.4437 14.7604 14.9549 15.0297 14.8799 15.4908C14.8555 15.6404 14.8837 15.8499 14.9444 15.9714C14.9643 16.0113 15.6517 16.7162 16.4719 17.5379L17.9632 19.0319L16.485 20.5139C15.672 21.329 14.9845 22.0337 14.9572 22.0799C14.8855 22.2014 14.85 22.4273 14.8788 22.579C14.9103 22.7453 14.9746 22.8634 15.0997 22.9848C15.2488 23.1293 15.3992 23.1892 15.6132 23.1892C15.9513 23.1892 15.8835 23.2455 17.5495 21.5813L19.0313 20.1012L20.5135 21.5788C21.6879 22.7496 22.0206 23.0683 22.1157 23.1135C22.2557 23.1801 22.4986 23.2022 22.648 23.162C22.9028 23.0934 23.1347 22.8408 23.1802 22.5823C23.2082 22.4233 23.1828 22.2201 23.119 22.0924C23.0991 22.0525 22.4118 21.3476 21.5916 20.526L20.1004 19.0321L21.5809 17.55C23.2445 15.8845 23.189 15.9513 23.189 15.6146C23.189 15.3939 23.1252 15.2389 22.9724 15.0888C22.7807 14.9005 22.5339 14.8298 22.271 14.8878Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_30492_97">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTextRemoveFormatting.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextRemoveFormatting.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextRemoveFormatting.prototype, "size", void 0);
if (customElements.get('cat-icon-text-remove-formatting') === undefined) {
    customElements.define('cat-icon-text-remove-formatting', BlocksIconTextRemoveFormatting);
}
